import { Link } from "react-router-dom";

function BookingSuccess() {

  return (

    <div className="container mt-5">

      <div className="card">

        <div className="card-body text-center">

          <h2>

            🎉 Meeting Booked Successfully

          </h2>

          <p>

            Google Meet Invitation
            has been sent.

          </p>

          <Link

            to="/"

            className="btn btn-success"

          >

            Done

          </Link>

        </div>

      </div>

    </div>

  );

}

export default BookingSuccess;